<template>
  <div>
    <img src="../assets/img/winner_top.png" class="titleImg" />
    <div class="wrap">
      <div class="winner_title">
        <el-row>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(1)">
              <div class="winner_flag">
                <img src="../assets/img/dxb.png" />

                <div class="title_content">
                  <p>2796元/年</p>
                  <p>每日精选3-5只潜力股</p>
                  <p>注册可免费阅读</p>
                </div>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(2)">
              <div class="winner_flag">
                <img src="../assets/img/nrng.png" />

                <div class="title_content">
                  <p>3600元/年</p>
                  <p>大数据选股 追踪实盘牛人</p>
                  <p>注册可免费阅读</p>
                </div>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(3)">
              <div class="winner_flag">
                <img src="../assets/img/wcs.png" />
                <div class="title_content">
                  <p>3456元/年</p>
                  <p>金牌投顾每日推荐热点股</p>
                  <p>注册可免费阅读</p>
                </div>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(4)">
              <div class="winner_flag">
                <img src="../assets/img/wpjm.png" />
                <div class="title_content">
                  <p>7188元/年</p>
                  <p>每日精选 狙击尾盘</p>
                  <p>注册可免费阅读</p>
                </div>
              </div>
            </a>
          </el-col>
        </el-row>
      </div>
      <hr class="grey_line" />
      <div class="found_winner">
        <div class="stock_list" style="min-height: 300px">
          <el-row>
            <el-col :span="6">
              <div class="stock_name">最新股票池</div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="more">
                <el-button type="text" @click="isLogin('stock_today')"
                  >更多</el-button
                >
              </div>
            </el-col>
          </el-row>
          <div class="found_winner_title">
            <el-row>
              <el-col :span="6">
                <h4>股票名</h4>
              </el-col>
              <el-col :span="6">
                <h4>关注价</h4>
              </el-col>
              <el-col :span="6">
                <h4>最高价</h4>
              </el-col>
              <el-col :span="6">
                <h4>最大涨幅</h4>
              </el-col>
            </el-row>
          </div>
          <div
            class="found_winner_list"
            v-for="(item, index) in stock_today.slice(0, 3)"
            :key="index"
          >
            <el-row>
              <el-col :span="6">
                <div class="stock_name">
                  <p v-if="$store.state.loginType">{{ item.stock_name }}</p>
                  <p v-if="$store.state.loginType">{{ item.stock_code }}</p>
                  <router-link to="/login/register" v-else style="color: white">
                    <p>注册登陆可读</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <p>{{ item.focus_price }}</p>
                  <p>{{ item.focus_time }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <p>{{ item.high_price }}</p>
                  <p>{{ item.high_time }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details red" v-if="item.stock_status != 1">
                  {{ (Number(item.changepercent) * 100).toFixed(2) }}%
                </div>
                <div class="stock_details red" v-else>- -</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="stock_list">
          <el-row>
            <el-col :span="6">
              <div class="stock_name">近15日涨幅排行榜</div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="more">
                <el-button type="text" @click="isLogin('stock_history')"
                  >更多</el-button
                >
              </div>
            </el-col>
          </el-row>
          <div class="found_winner_title">
            <el-row>
              <el-col :span="6">
                <h4>股票名</h4>
              </el-col>
              <el-col :span="6">
                <h4>关注价</h4>
              </el-col>
              <el-col :span="6">
                <h4>最高价</h4>
              </el-col>
              <el-col :span="6">
                <h4>最大涨幅</h4>
              </el-col>
            </el-row>
          </div>
          <div
            class="found_winner_list"
            v-for="(item, index) in stock_history.slice(0, 5)"
            :key="index"
          >
            <el-row>
              <el-col :span="6">
                <div class="stock_name">
                  <p>{{ item.stock_name }}</p>
                  <p>{{ item.stock_code }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <p>{{ item.focus_price }}</p>
                  <p>{{ item.focus_time }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <p>{{ item.high_price }}</p>
                  <p>{{ item.high_time }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details red" v-if="item.stock_status != 1">
                  {{ (Number(item.changepercent) * 100).toFixed(2) }}%
                </div>
                <div class="stock_details red" v-else>- -</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <el-dialog
        title="最新股票池"
        :visible.sync="stock_today_status"
        width="1000px"
      >
        <el-table :data="stock_today" style="width: 100%">
          <el-table-column prop="stock_name" align="center" label="名称">
          </el-table-column>
          <el-table-column prop="stock_code" align="center" label="代码">
          </el-table-column>
          <el-table-column prop="focus_price" align="center" label="关注价">
          </el-table-column>
          <el-table-column prop="high_time" align="center" label="关注时间">
          </el-table-column>
          <el-table-column prop="high_price" align="center" label="最高价">
          </el-table-column>
          <el-table-column prop="high_time" align="center" label="最高时间">
          </el-table-column>
          <el-table-column align="center" label="最大涨幅">
            <template slot-scope="scope">
              <span v-if="scope.row.stock_status != 1"
                >{{ (Number(scope.row.changepercent) * 100).toFixed(2) }}%</span
              >
              <span v-else>- -</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stock_today_status = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="近15日涨幅排行榜"
        :visible.sync="stock_history_status"
        width="1000px"
      >
        <el-table :data="stock_history" style="width: 100%">
          <el-table-column prop="stock_name" align="center" label="名称">
          </el-table-column>
          <el-table-column prop="stock_code" align="center" label="代码">
          </el-table-column>
          <el-table-column prop="focus_price" align="center" label="关注价">
          </el-table-column>
          <el-table-column prop="high_time" align="center" label="关注时间">
          </el-table-column>
          <el-table-column prop="high_price" align="center" label="最高价">
          </el-table-column>
          <el-table-column prop="high_time" align="center" label="最高时间">
          </el-table-column>
          <el-table-column align="center" label="最大涨幅">
            <template slot-scope="scope">
              <span v-if="scope.row.stock_status != 1"
                >{{ (Number(scope.row.changepercent) * 100).toFixed(2) }}%</span
              >
              <span v-else>- -</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stock_history_status = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "FoundWinners",
  data() {
    return {
      stock_today: [],
      stock_today_status: false,
      stock_history: [],
      stock_history_status: false,
      activeColor: "red",
    };
  },
  methods: {
    getCode(classify) {
      let that = this;
      that
        .$http({
          url: "/", //请求地址
          method: "post",
          data: {
            nozzle: "found_winner",
            action: "found_winner",
            classify: classify,
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            let data = resData.data;
            let stock_today = [];
            let stock_history = [];
            for (let i = 0, len = data.length; i < len; i++) {
              switch (data[i].status) {
                case 0:
                  stock_history.push(data[i]);
                  break;
                case 1:
                  stock_today.push(data[i]);
                  break;
              }
            }
            that.stock_today = stock_today;
            that.stock_history = stock_history;
          } else {
          }
        });
    },
    isLogin(type) {
      let that = this;
      if (this.$store.state.loginType) {
        switch (type) {
          case "stock_today":
            that.stock_today_status = true;
            break;
          case "stock_history":
            that.stock_history_status = true;
            break;
        }
      } else {
        that.$message({
          message: "您还未登录,前去登录",
          type: "error",
          onClose: function () {
            that.$router.push({
              path: "/login",
            });
          },
        });
      }
    },
  },
  mounted: function () {
    let that = this;
    that.getCode(1);
  },
  beforeDestroy() {
    clearInterval(this.chatTimer);
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: max-content;
  background-size: cover;
  overflow: hidden;
  background-position: center center;
  position: relative;
  background-color: white;
  padding-top: 30px !important;
  padding-bottom: 30px;
}

.titleImg {
  width: 100%;
}

.winner_title {
  width: 1200px;
  margin-top: 0 !important;
  margin: 80px auto 0;
}

.winner_flag {
  text-align: center;
}

.winner_flag img {
  height: 50px;
}

.winner_flag img:hover + .title_content {
  height: 80px;
}

.grey_line {
  border-color: #ffffff87;
  margin-top: 30px;
}

.found_winner {
  position: initial;
  width: 1200px;
  padding: 50px 100px 50px 100px;
  background-color: white;
  left: 0;
  right: 0;
  top: 200px;
  margin: auto;
}

.stock_list {
  margin-bottom: 50px;
}

.title_content {
  background: white;
  width: 192px;
  height: 0;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 5px;
  transition: height 0.4s;
  -moz-transition: height 0.4s; /* Firefox 4 */
  -webkit-transition: height 0.4s; /* Safari and Chrome */
  -o-transition: height 0.4s; /* Opera */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #333;
}

.title_content:hover {
}

.found_winner_title {
  width: 100%;
  margin: 30px auto 0px;
}

.found_winner_title h4 {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: red;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.found_winner_list {
  background: rgb(235, 235, 235);
  height: 50px;
  border-radius: 50px;
  margin-top: 40px;
  -moz-box-shadow: 5px 5px 5px #999; /* 老的 Firefox */
  box-shadow: 3px 3px 5px #999;
}

.stock_name {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  height: 50px;
  text-align: center;
  background: #b27a24;
  border-radius: 50px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.stock_details {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  text-align: center;
  height: 50px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.red {
  color: red;
}

.more {
  line-height: 50px;
  text-align: center;
}
.stockPopup {
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/FoundWinners.vue